import CheckCircleRounded from "@mui/icons-material/CheckCircleRounded";
import ErrorRounded from "@mui/icons-material/ErrorRounded";
import SaveRounded from "@mui/icons-material/SaveRounded";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDataGridSettings } from "@/components/DataGridSettingsProvider";

export default function SaveTableButton() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const { t } = useTranslation();
  const { saveGridState } = useDataGridSettings();
  const handleButtonClick = async () => {
    setStatus("loading");
    const result = await saveGridState();
    if (result) {
      setStatus("success");
      setTimeout(() => setStatus("idle"), 3000);
    } else {
      setStatus("error");
      setTimeout(() => setStatus("idle"), 3000);
    }
  };

  const renderButtonIcon = () => {
    if (status === "loading") return <CircularProgress size={20} />;
    if (status === "success") return <CheckCircleRounded color="success" />;
    if (status === "error") return <ErrorRounded color="error" />;
    return <SaveRounded fontSize="inherit" />;
  };
  return (
    <Button
      color="primary"
      onClick={handleButtonClick}
      size="small"
      disabled={status === "loading"}
      startIcon={renderButtonIcon()}
    >
      {t("faultOverview.saveTable")}
    </Button>
  );
}
